<template>
  <div
    class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in"
    :style="{ '--switch-success-color': successColor || '#337E33' }"
  >
    <input
      :id="id"
      :checked="checked"
      type="checkbox"
      name="toggle"
      class="toggle-checkbox absolute block w-6 h-6 rounded-full pointer-events-none
        bg-white border-2 appearance-none cursor-pointer checked:place-content-end
        checked:object-right"
      :aria-labelledby="ariaLabelledby || undefined"
      :aria-describedby="ariaDescribedby || undefined"
      @change="handleInputChange"
    >
    <label
      :for="id"
      class="toggle-label block
        overflow-hidden h-6 rounded-full bg-gray-300
        cursor-pointer checked:bg-green-400"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Switch',
  props: {
    id: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean
    },
    label: {
      type: String,
      default: ''
    },
    ariaLabelledby: {
      type: String,
      default: ''
    },
    ariaDescribedby: {
      type: String,
      default: ''
    },
    successColor: {
      type: String,
      default: '#337E33'
    }
  },
  emits: ['update:checked'],
  methods: {
    handleInputChange(event: Event) {
      const target = event.target as HTMLInputElement;
      this.$emit('update:checked', target.checked);
    }
  }
});
</script>
<style>
/* CHECKBOX TOGGLE SWITCH */
/* @apply rules for documentation, these do not work as inline style */
.toggle-checkbox:checked {
  right: 0;
  border-color: var(--switch-success-color);
}
.toggle-checkbox:checked + .toggle-label {
  background-color: var(--switch-success-color);
}
</style>
